import { legacyPluginToNextMap } from "./../ricos-schema/next-schema/plugin-names.js";
const hasPlugin = (pluginType, plugins) => !!plugins?.some(
  (plugin) => plugin.type === pluginType || plugin.type === legacyPluginToNextMap[pluginType]
);
export {
  hasPlugin
};
//# sourceMappingURL=has-plugin.js.map
